import Plyr from 'plyr';

$(document).ready(function () {
    $('.recording-modal').each(function () {
        const modal = this;
        const video = modal.querySelector('video');

        if (!video) return;

        const originalSources = Array.from(video.querySelectorAll('source')).map(source => ({
            element: source,
            src: source.getAttribute('src')
        }));

        const player = new Plyr(video, {
            fullscreen: { enabled: false }
        });

        if (player.elements?.container) {
            player.elements.container.addEventListener('dblclick', function (event) {
                event.preventDefault();
                event.stopPropagation();
            });

            let lastTap = 0;
            player.elements.container.addEventListener('touchend', function (event) {
                const currentTime = new Date().getTime();
                const tapLength = currentTime - lastTap;

                if (tapLength < 300 && tapLength > 0) {
                    event.stopPropagation();
                }

                lastTap = currentTime;
            });
        }

        function stopVideoHard() {
            try {
                player.pause();
            } catch (e) {}

            video.pause();
            video.currentTime = 0;

            originalSources.forEach(item => {
                item.element.setAttribute('src', '');
            });

            video.load();

            originalSources.forEach(item => {
                item.element.setAttribute('src', item.src);
            });

            video.load();
        }

        function playVideoSafe() {
            video.load();
            player.play().catch(() => {});
        }

        modal.addEventListener('shown.bs.modal', playVideoSafe);
        modal.addEventListener('hide.bs.modal', stopVideoHard);
        modal.addEventListener('hidden.bs.modal', stopVideoHard);

        const closeBtn = modal.querySelector('[data-dismiss="modal"], [data-bs-dismiss="modal"], .close');
        if (closeBtn) {
            closeBtn.addEventListener('click', stopVideoHard);
        }
    });

    $('.audio-modal').each(function () {
        const modal = this;
        const audio = modal.querySelector('audio');

        if (!audio) return;

        function stopAudioHard() {
            audio.pause();
            audio.currentTime = 0;
            audio.load();
        }

        function playAudioSafe() {
            audio.play().catch(() => {});
        }

        modal.addEventListener('shown.bs.modal', playAudioSafe);
        modal.addEventListener('hide.bs.modal', stopAudioHard);
        modal.addEventListener('hidden.bs.modal', stopAudioHard);

        const closeBtn = modal.querySelector('[data-dismiss="modal"], [data-bs-dismiss="modal"], .close');
        if (closeBtn) {
            closeBtn.addEventListener('click', stopAudioHard);
        }
    });
});